/* eslint-disable no-param-reassign */
import Vue from "vue";
import Vuex from "vuex";
import { appTitle } from "../conf";
import user from "./user";
import calendar from "./calendar";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isCalendarVisible: false,
    appTitle,
  },
  mutations: {
    toggleCalendar(state) {
      state.isCalendarVisible = !state.isCalendarVisible;
    },
  },
  getters: {
    appTitle: state => state.appTitle,
    isCalendarVisible: state => state.isCalendarVisible,
  },
  modules: {
    user,
    calendar,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js